<template>
  <div class="tw:flex tw:flex-col tw:items-center">
    <div
      class="tw:flex tw:justify-between tw:items-center tw:gap-2 tw:bg-[#031F2A] tw:px-4 tw:border tw:border-[#1E353E] tw:rounded-4xl tw:w-full tw:h-12"
    >
      <div class="tw:flex tw:items-center tw:gap-2 tw:w-full">
        <IconSearch class="tw:w-6 tw:h-6" />
        <UIInput v-model="search" class="tw:w-full" />
      </div>

      <div
        v-if="$device.isDesktopOrTablet && !$props.hideBalanceCheck"
        class="tw:hidden tw:sm:flex tw:items-center tw:gap-2 tw:bg-[#040F14] tw:px-4 tw:rounded-4xl tw:outline tw:outline-[#1E353E] tw:cursor-pointer tw:shrink-0"
        @click="handleWithBalanceOnlyChange"
      >
        <span>{{ $t('walletWithBalanceOnly') }}</span>
        <UICheckbox v-model="withBalanceOnly" :label="$t('walletWithBalanceOnly')" />
      </div>
    </div>
    <div
      v-if="$device.isMobile"
      class="tw:sm:hidden tw:flex tw:justify-center tw:items-center tw:gap-2 tw:bg-[#040F14] tw:px-4 tw:py-2 tw:rounded-b-2xl tw:outline tw:outline-[#1E353E] tw:w-full tw:max-w-72 tw:cursor-pointer tw:shrink-0"
      @click="handleWithBalanceOnlyChange"
    >
      <span>{{ $t('walletWithBalanceOnly') }}</span>
      <UICheckbox v-model="withBalanceOnly" label="With balance only" />
    </div>
  </div>
</template>

<script lang="ts" setup>
const search = defineModel<string>({ required: true });
const withBalanceOnly = defineModel<boolean>('withBalanceOnly', { required: true });

defineProps<{
  hideBalanceCheck?: boolean;
}>();

const handleWithBalanceOnlyChange = () => (withBalanceOnly.value = !withBalanceOnly.value);
</script>
